/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import type { JSX } from 'react';

export function NotFoundPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <p className="text-6xl font-black text-slate-200">404</p>
      <p className="text-lg font-semibold text-slate-700">{t('common.notFound')}</p>
      <Link
        to="/"
        className="focus-ring bg-brand-600 hover:bg-brand-700 rounded-lg px-4 py-2 text-sm font-medium text-white"
      >
        {t('common.backHome')}
      </Link>
    </div>
  );
}
